import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  PIPELINEDETAILS_FEATURE_KEY,
  PipelinedetailsState,
  PipelinedetailsPartialState,
  pipelinedetailsAdapter,
} from "./pipelinedetails.reducer";
import { PipelineDetailsDto } from "@cradua/data";

// Lookup the 'Pipelinedetails' feature state managed by NgRx
export const getPipelinedetailsState = createFeatureSelector<
  PipelinedetailsPartialState,
  PipelinedetailsState
>(PIPELINEDETAILS_FEATURE_KEY);

const { selectAll, selectEntities } = pipelinedetailsAdapter.getSelectors();

// export const getPipelinedetailsLoaded = createSelector(
//   getPipelinedetailsState,
//   (state: PipelinedetailsState) => state.loaded,
// );

export const getPipelinedetailsError = createSelector(
  getPipelinedetailsState,
  (state: PipelinedetailsState) => state.error,
);

export const loadingPipelinedetails = createSelector(
  getPipelinedetailsState,
  (state: PipelinedetailsState) => state.loaded,
);

export const getAllPipelinedetails = createSelector(
  getPipelinedetailsState,
  (state: PipelinedetailsState) => selectAll(state),
);

export const getPipelinedetailsEntities = createSelector(
  getPipelinedetailsState,
  (state: PipelinedetailsState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getPipelinedetailsState,
  (state: PipelinedetailsState) => state.selectedPipelinedetailsId,
);

export const getSelected = createSelector(
  getPipelinedetailsEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

export const getLastInsertedValue = createSelector(
  getAllPipelinedetails,
  (pipelinedetails: PipelineDetailsDto[]) => pipelinedetails[0],
);

export const getSearchPipelinedetails = createSelector(
  getAllPipelinedetails,
  getSelectedId,
  (pipelinedetails: PipelineDetailsDto[], selectedId) => {
    if (selectedId === ".") {
      return pipelinedetails;
    }

    return !selectedId ? null : pipelinedetails.filter(
      (item) =>
        item.PipelineCode.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.PipelineName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        )
    );
  },
);

export const getSearchpipelinedetailsId = createSelector(
  getAllPipelinedetails,
  getSelectedId,
  (pipelinedetails: PipelineDetailsDto[], selectedId) =>
    pipelinedetails.find((item) => item.id === selectedId),
);